import { render } from "./SuccessAlert.vue?vue&type=template&id=2c7ef2ff&ts=true"
import script from "./SuccessAlert.vue?vue&type=script&lang=ts"
export * from "./SuccessAlert.vue?vue&type=script&lang=ts"

import "./SuccessAlert.vue?vue&type=style&index=0&id=2c7ef2ff&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__